<div class="col-md-10">
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <a
        href="#"
        class="nav-link"
        (click)="setMelodyGroup('antique')"
        [ngClass]="{ active: melodyGroup === 'antique' }"
      >
        <h5>{{ "antique" | translate }}</h5>
      </a>
    </li>
    <li class="nav-item">
      <a
        href="#"
        class="nav-link"
        (click)="setMelodyGroup('byzantine')"
        [ngClass]="{ active: melodyGroup === 'byzantine' }"
      >
        <h5>{{ "byzantine" | translate }}</h5>
      </a>
    </li>
    <li class="nav-item">
      <a
        href="#"
        class="nav-link"
        (click)="setMelodyGroup('tempered')"
        [ngClass]="{ active: melodyGroup === 'tempered' }"
      >
        <h5>{{ "tempered" | translate }}</h5>
      </a>
    </li>
  </ul>
  <app-melody-item
    *ngFor="let melodyEl of melodies"
    [melody]="melodyEl"
  ></app-melody-item>
</div>
